module.exports = __webpack_public_path__ + "img/pin_transport_red.cabb7182.svg";